import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { faCloud } from '@fortawesome/free-solid-svg-icons';
import { EditEnvironmentActions } from '../../../../enums/EditEnvironment.enum';
import { SingleEnvironmentDetails } from 'src/app/models/single-environment-details.model';
import { ServerCount } from 'src/app/models/server-count.model';
import { EnvironmentService } from '../../shopping-cart/services/environment.service';

@Component({
  selector: 'app-edit-environment',
  templateUrl: './edit-environment.component.html',
  styleUrls: ['./edit-environment.component.sass']
})
export class EditEnvironmentComponent implements OnInit {

  icons: any;
  wizardTabs: string[];
  tabIndex: number;
  title: string;
  planSelectionAllowed: boolean = true;
  IsConfirmationTab: boolean;
  EditActions = EditEnvironmentActions

  serverDetail: ServerCount
  subscriptionId: string;
  environmentName: string;
  environmentInfo: SingleEnvironmentDetails
  annualMachinesAllowed: boolean = true;

  constructor(
    private environmentService: EnvironmentService, 
    private route: ActivatedRoute,
  ) {
    this.wizardTabs = [];
    this.tabIndex = 0;
    this.IsConfirmationTab = false;
  }

  ngOnInit(): void {
    this.initializeIcons();
    this.setWizardTabs();
    this.title = "Add Server(s)";
    this.route.params.subscribe(params => {
      this.subscriptionId = params.subscriptionId
      this.environmentName = params.environmentId
    });
  }

  ngAfterViewInit(): void {
    // this.environmentService.checkAnnualMachineCreation(this.subscriptionId)
    //   .subscribe((result) => {
    //     this.annualMachinesAllowed = result;
    // })
    this.initializeEnvironment();
    // this.costcalculatorService.getBillabledDimensions(this.subscriptionId)
    //   .subscribe((result) => {
    //     this.costcalculatorService.setPricing(result)
    //   })
  }

  initializeEnvironment(){
    this.environmentService.getSingleEnvironmentDetails(this.environmentName, this.subscriptionId).subscribe(data => {
        this.environmentInfo = data;
    });
  }

  initializeIcons() {
    this.icons = {};
    this.icons.faCloud = faCloud;
  }

  setWizardTabs() {
    delete this.wizardTabs;
    this.wizardTabs = [];
    this.wizardTabs.push(EditEnvironmentActions.AddServer);
    this.wizardTabs.push(EditEnvironmentActions.ReviewPurchase);
  }

  updateWindowTitle(title: string): void {
    this.title = title;
  }

  onWizardTabChange(tabIndex: any) {
    this.tabIndex = tabIndex;
  }

  passServerDetails(serverDetail: ServerCount) {
    this.serverDetail = serverDetail    
  }


}
